import React from 'react';
import { Header } from '../../../components/ToxicDetector/Header';
import { HeroSection } from '../../../components/ToxicDetector/HeroSection';
import { TrustSection } from '../../../components/ToxicDetector/TrustSection';
import { FeaturesSection } from '../../../components/ToxicDetector/FeaturesSection';
import { GuaranteesSection } from '../../../components/ToxicDetector/GuaranteesSection';
import { ToolsSection } from '../../../components/ToxicDetector/ToolsSection';
import { ComparisonSection } from '../../../components/ToxicDetector/ComparisonSection';
import { PricingSection } from '../../../components/ToxicDetector/PricingSection';
import { FAQSection } from '../../../components/ToxicDetector/FAQSection';
import { CTASection } from '../../../components/ToxicDetector/CTASection';
import { Footer } from '../../../components/ToxicDetector/Footer';
import { MetaTags } from '../../../components/SEO/MetaTags';
import { PromoBanner } from '../../../components/Notifications/PromoBanner';
import { GoogleTranslateWidget } from '../../../components/GoogleTranslateWidget';
export function LandingPageHI() {
  const alternateUrls = [{
    lang: 'en',
    url: 'https://toxicdetector.com/'
  }, {
    lang: 'pt-BR',
    url: 'https://toxicdetector.com/pt/'
  }, {
    lang: 'es-MX',
    url: 'https://toxicdetector.com/es/'
  }, {
    lang: 'ja',
    url: 'https://toxicdetector.com/ja/'
  }, {
    lang: 'ko',
    url: 'https://toxicdetector.com/ko/'
  }, {
    lang: 'de',
    url: 'https://toxicdetector.com/de/'
  }, {
    lang: 'fr',
    url: 'https://toxicdetector.com/fr/'
  }, {
    lang: 'hi',
    url: 'https://toxicdetector.com/hi/'
  }, {
    lang: 'id',
    url: 'https://toxicdetector.com/id/'
  }];
  return <>
      <MetaTags title="ToxicDetector: AI संबंध विश्लेषण | जहरीले पैटर्न और गैसलाइटिंग का पता लगाएं" description="पता करें कि क्या आपका पूर्व-साथी समस्या है। हेरफेर, गैसलाइटिंग और लाल झंडों के तत्काल, गोपनीय विश्लेषण के लिए अपनी चैट को ToxicDetector के AI पर अपलोड करें। आज ही मुफ्त स्कैन शुरू करें।" keywords="AI संबंध विश्लेषण, जहरीले पैटर्न का पता लगाएं, गैसलाइटिंग डिटेक्टर, जहरीला पूर्व, हेरफेर चेकर, संबंध विषाक्तता, AI टेक्स्ट स्कैनर" canonical="https://toxicdetector.com/hi" language="hi" alternateUrls={alternateUrls} data-id="element-6426" data-mp="2rp4mbc4r0h1" />
      <GoogleTranslateWidget data-id="element-6427" data-mp="28wqdpvxxi90p" />
      <PromoBanner data-id="element-6428" data-mp="28xi7d17ytwoc" />
      <div className="flex flex-col w-full min-h-screen bg-gradient-to-b from-stone-50 to-white" data-id="element-6429" data-mp="2durw0enj64b4">
        <Header data-id="element-6430" data-mp="2hwdhgoe4rqwx" />
        <main data-id="element-6431" data-mp="2hvtxz38u0ugs">
          <HeroSection h1Override={<>
                आपका दिमाग आपसे{' '}
                <span className="relative inline-block" data-id="element-6433" data-mp="2mo3u510jiqri">
                  <span className="relative z-10 text-transparent bg-clip-text bg-gradient-to-b from-gray-200 to-gray-500" data-id="element-6434" data-mp="1q55wtr75rp34">
                    झूठ
                  </span>
                  <span className="absolute top-1/2 left-0 w-full h-[4px] md:h-[6px] bg-[#FF0000] -translate-y-1/2 rotate-[-2deg]" data-id="element-6435" data-mp="1u4y7c9g445b4" />
                </span>{' '}
                बोल रहा है।
                <br data-id="element-6436" data-mp="1hootuaubhdxl" />
                <span className="text-[#FF0000] drop-shadow-[0_0_30px_rgba(255,0,0,0.4)]" data-id="element-6437" data-mp="1hmcf06juvjor">
                  हमारा AI नहीं।
                </span>
              </>} data-id="element-6432" data-mp="2hw3msni54vkw" />
          <TrustSection data-id="element-6438" data-mp="18n7j77zoi4ga" />
          <FeaturesSection data-id="element-6439" data-mp="13oe3ra0u03dh" />
          <GuaranteesSection data-id="element-6440" data-mp="13ons6t68a2h2" />
          <ToolsSection data-id="element-6441" data-mp="13pywcu3l5c8p" />
          <ComparisonSection data-id="element-6442" data-mp="13q8purnua1j5" />
          <PricingSection data-id="element-6443" data-mp="yx5r8547g1w3" />
          <FAQSection data-id="element-6444" data-mp="yww2ekuwc0rz" />
          <CTASection data-id="element-6445" data-mp="ywcqplvua8me" />
        </main>
        <Footer data-id="element-6446" data-mp="tyb8t4a5gfci" />
      </div>
    </>;
}